import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableMui from './TableMui';
import moment from 'moment-timezone';
import getTableOptions from '../constants/TableOptions';
// import { checkCols } from '../constants/EmployeeCols'
import LambdaFetch from '../functions/FetchFromLambda';
import fetchFromAthena from '../functions/FetchFromAthena';
import PayStubDetails from '../components/PaystubDetails';
import {
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { dateFormat } from '../utils/formatter';
import ReactTable from '../components/ReactTable';
import { useCheckCols } from '../hooks/EmployeeCols';
import LoadingLink from './LoadingLink'

const useStyles = makeStyles((theme) => ({
  root: {
    // border: '1px solid rgba(0, 0, 0, .125)',
    // boxShadow: 'none',
    // '&:not(:last-child)': {
    //   borderBottom: 0,
    // },
    // '&:before': {
    //   display: 'none',
    // },
    // '&$expanded': {
    //   margin: 'auto',
    // },
  },
  tabsummary: {
    backgroundColor: 'rgba(0, 0, 0, 0.025)',
  },
  appBar: {
    position: 'relative',
  },
  accordionDets: {
    display: 'block',
  },
}));

export default function EmployeeChecks(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);
  const [checkDetails, setCheckDetails] = React.useState(null);

  // Reset component state when employee changes
  React.useEffect(() => {
    setExpanded(false)
    setCheckDetails(null)
  }, [props.empId])

  const checkCols = useCheckCols();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleClose = () => {
    setCheckDetails(null);
  };

  const getCheckDetails = async (checkId) => {
    try {
      // Prepare parameters for Athena queries
      const athenaParams = {
        company: props.company,
        empId: props.empId,
        objId: checkId
      };

      // Call all three Athena queries in parallel
      const [paystubDed, paystubWage, paystubDist] = await Promise.all([
        fetchFromAthena({
          queryName: 'paystub_ded_read',
          headers: athenaParams,
          accessToken: props.accessToken,
          credentials: props.fetchInitialData.credentials
        }),
        fetchFromAthena({
          queryName: 'paystub_wage_read',
          headers: athenaParams,
          accessToken: props.accessToken,
          credentials: props.fetchInitialData.credentials
        }),
        fetchFromAthena({
          queryName: 'paystub_distrib_read',
          headers: athenaParams,
          accessToken: props.accessToken,
          credentials: props.fetchInitialData.credentials
        })
      ]);

      const data = {
        paystubWage: paystubWage || [],
        paystubDed: paystubDed || [],
        paystubDist: paystubDist || [],
        main: props.data.find((check) => check.CHECK_ID === checkId)
      };

      setCheckDetails(data);
    } catch (error) {
      console.error('Error fetching paystub details:', error);
      setCheckDetails(null);
    }
  };

  // Show loading when isLoading is true and we don't have data yet
  const isLoading = Boolean(props.isLoading);
  const hasData = props.data && Array.isArray(props.data) && props.data.length > 0;
  
  // Show loading spinner when loading and no data
  if (isLoading && !hasData) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  // Show empty state if no data and not loading
  if (!hasData && !isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <Typography variant="subtitle1">No pay data</Typography>
      </Box>
    );
  }

  const yrs = props.data.reduce((yrs, cur) => {
    if (yrs.indexOf(cur.YEAR) === -1) {
      return [...yrs, cur.YEAR];
    } else {
      return yrs;
    }
  }, []);
  return (
    <div>
      {checkDetails && (
        <PayStubDetails
          {...props}
          handleClose={handleClose}
          checkDetails={checkDetails}
        />
      )}

      {yrs.sort().map((yr) => {
        const tableData = props.data
          .filter((r) => r.YEAR === yr)
          .map((row) => {
            return {
              ...row,
              CHECK_VIEW: (
                <LoadingLink
                  className="editLink"
                  onClick={() => getCheckDetails(row.CHECK_ID)}
                >
                  {row.CHECK_ID}
                </LoadingLink>
              ),
            };
          });

        return (
          <div key={yr}>
            <Accordion
              square
              expanded={expanded === yr}
              onChange={handleChange(yr)}
            >
              <AccordionSummary
                className={classes.tabsummary}
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>{yr}</Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDets}>
                <ReactTable cols={checkCols} data={tableData} isLoading={props.isLoading} />
              </AccordionDetails>
            </Accordion>
          </div>
        );
      })}
    </div>
  );
}
